import "../styles/styles.scss";
import { initDatadogRumIfTrackingEnabled } from "./tracking/DatadogRumInitializer";
// statically include language data for now
import * as ReactIntl from "react-intl";
const addLocaleData = ReactIntl.addLocaleData;
import bg from "react-intl/locale-data/bg";
import cs from "react-intl/locale-data/cs";
import de from "react-intl/locale-data/de";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import fr from "react-intl/locale-data/fr";
import hi from "react-intl/locale-data/hi";
import hr from "react-intl/locale-data/hr";
import hu from "react-intl/locale-data/hu";
import it from "react-intl/locale-data/it";
import nl from "react-intl/locale-data/nl";
import pl from "react-intl/locale-data/pl";
import pt from "react-intl/locale-data/pt";
import pa from "react-intl/locale-data/pa";
import ro from "react-intl/locale-data/ro";
import mo from "react-intl/locale-data/mo";
import ru from "react-intl/locale-data/ru";
import kk from "react-intl/locale-data/kk";
import sk from "react-intl/locale-data/sk";
import sr from "react-intl/locale-data/sr";
import tr from "react-intl/locale-data/tr";
import uk from "react-intl/locale-data/uk";
import ur from "react-intl/locale-data/ur";
import vi from "react-intl/locale-data/vi";
addLocaleData(bg);
addLocaleData(cs);
addLocaleData(de);
addLocaleData(en);
addLocaleData(es);
addLocaleData(fr);
addLocaleData(hi);
addLocaleData(hr);
addLocaleData(hu);
addLocaleData(it);
addLocaleData(nl);
addLocaleData(pl);
addLocaleData(pt);
addLocaleData(pa);
addLocaleData(ro);
addLocaleData(mo);
addLocaleData(ru);
addLocaleData(kk);
addLocaleData(sk);
addLocaleData(sr);
addLocaleData(tr);
addLocaleData(uk);
addLocaleData(ur);
addLocaleData(vi);
import { intlProvider } from "./IntlRootMixin";
import { App as AppComponent } from "./components/App";
import React from "react";
import { render } from "react-dom";
import { IntlProvider } from "react-intl";
import { Router } from "react-router";
import ABFeatureTogglePage from "./components/ABFeatureTogglePage";
import { TagPrison } from "./components/TagPrison";
import { LogoutPage } from "./components/LogoutPage";
import { NotFoundPage } from "./components/NotFoundPage";
import LoginParkingPage from "./components/LoginParkingPage";
import Tracking from "./uidispatcherapi/Tracking";
import { RedirectTiers } from "./hooks/RedirectTiers";
import ScrollTracking from "./tracking/ScrollTracking";
import AuthHooks from "auth_util/hooks";
import { SessionStore } from "./uidispatcherapi/SessionStore";
import LoginStore from "./uidispatcherapi/LoginStore";
import { routes as ocUIRoutes } from "./routes/ocUi";
import { routes as ciaUIRoutes } from "./routes/ciaUi";
import { LandingPage, routes as exploreUIRoutes } from "./routes/exploreUi";
import { routes as caBoUIRoutes } from "./routes/caBoUi";
import { routes as ciBoUIRoutes } from "./routes/ciBoUi";
import { routes as sdBoUIRoutes } from "./routes/sdBoUi";
import { routes as sdPdpUIRoutes } from "./routes/sdPdpUi";
import { routes as sdArticlesarchUIRoutes } from "./routes/sdArticlesearchUi";
SessionStore.start();
import Reflux from "reflux";
import history from "./uidispatcherapi/BettyHistoryModule";
import { loadEnvironmentHook } from "./routes/environmentLoader";
import {
	customerSelectionHook,
	customersMustUseShop,
	employeesMustUseBackend,
	errorHook,
	HOOK_SKIPPED,
	selectBusinessAccount,
} from "./hooks/redirectUtil";
type Route = {
	component?: any;
	onEnter?: (nextState: any, replace: any, callback: any) => void | Promise<void>;
	onChange?: (previousState: any, nextState: any, replace: any) => void;
	childRoutes?: Array<Route>;
};
history.installHashRedirect();
let redirects = 0;
const routerHooks: any[] = [];
routerHooks.push(LoginStore.loginHook);
routerHooks.push(loadEnvironmentHook);

function setBrowserTitle() {
	const i18n = intlProvider.getChildContext();
	const title = i18n?.intl?.messages?.BROWSER_TITLE;

	if (title) {
		window.document.title = title;
	}
}

setBrowserTitle();
routerHooks.push(errorHook);
routerHooks.push(employeesMustUseBackend);
routerHooks.push(customersMustUseShop);
routerHooks.push(customerSelectionHook);
routerHooks.push(selectBusinessAccount);
routerHooks.push(async function (...args) {
	const hook = await import("explore_ui/SelectAddressHook").then(module => module.default);
	return hook(...args);
});

function getRouteProps(state) {
	const result = state.routes.reduce((currentParams, route) => {
		return { ...currentParams, ...route.routeParam };
	}, {});
	return result;
}

function buildStateForHook(nextState) {
	return {
		routeParams: nextState.routeParams,
		params: nextState.params,
		path: nextState.location.pathname,
		query: nextState.location.query,
	};
}

function trackingRouterHook(previousState, nextState, replace) {
	nextState.routeParams = getRouteProps(nextState);
	Tracking.hook.call(this, buildStateForHook(nextState), SessionStore, {
		transitionTo: function (path, query) {
			replace({
				pathname: path,
				query,
			});
		},
	});
}

async function callRouterHooks(nextState, replace, callback) {
	let error;

	if (!nextState.hooked) {
		nextState.hooked = true;
		nextState.routeParams = getRouteProps(nextState);

		if (redirects > 100) {
			error = new Error("too many redirects");
		} else {
			redirects++;
			let result = HOOK_SKIPPED;

			try {
				for (const hook of routerHooks) {
					if (result.checkNext) {
						result = await hook(buildStateForHook(nextState), SessionStore, {
							transitionTo: (path, query) =>
								replace({
									pathname: path,
									query,
								}),
						});
					}
				}
			} catch (e: any) {
				error = new Error("Error during routerHooks", { cause: e });
			}

			if (!result.didRedirect) {
				redirects = 0;
			}

			// This will prevent React Router from rendering the component if the hook did a redirect via window.location
			if (result.didNavigate) return;
		}
	}

	if (error) {
		console.error(error);
		callback(error);
	} else {
		callback();
	}
}

function addRouterHookHook(input: Route | Route[]) {
	const routes: Route[] = Array.isArray(input) ? input.flat(Infinity) : [input];
	routes.forEach(route => {
		if (route) {
			if (route.component) {
				route.onEnter = callRouterHooks;
				route.onChange = trackingRouterHook;
			}

			if (route.childRoutes) {
				addRouterHookHook(route.childRoutes);
			}
		}
	});
}

function buildRoutes() {
	const allRoutes = [
		...exploreUIRoutes(),
		...sdPdpUIRoutes(),
		...ocUIRoutes(),
		...ciaUIRoutes(),
		...sdArticlesarchUIRoutes(),
		...caBoUIRoutes(),
		...ciBoUIRoutes(),
		...sdBoUIRoutes(),
	];
	allRoutes.push({
		path: "/authLoading",
		component: LoginParkingPage,
		routeParam: {
			trackingName: "login_loading",
		},
	});
	allRoutes.push({
		path: "/login",
		component: LoginParkingPage,
		routeParam: {
			trackingName: "login_loading",
		},
		childRoutes: [
			{
				path: "/login/*",
				routeParam: {
					trackingName: "login_loading",
				},
			},
		],
	});
	allRoutes.push({
		path: "/logout",
		component: LogoutPage,
		routeParam: {
			trackingName: "logout",
			noCustomerNeed: true,
			publicVisible: true,
		},
	});
	allRoutes.push({
		path: "/featureToggling",
		component: ABFeatureTogglePage,
		routeParam: {
			trackingName: "featureToggling",
			noCustomerNeed: true,
		},
	});
	allRoutes.push({
		path: "/*",
		component: NotFoundPage,
		routeParam: {
			trackingName: "errorpage_404",
			visibleForAnonymous: true,
		},
	});
	const bettyRoutes = [
		{
			path: "/",
			component: AppComponent,
			indexRoute: {
				component: LandingPage,
				onEnter: callRouterHooks,
				onChange: trackingRouterHook,
				routeParam: {
					trackingName: "homepage",
					visibleForAnonymous: true,
				},
			},
			childRoutes: allRoutes,
		},
	];
	addRouterHookHook(allRoutes);
	return bettyRoutes;
}

const routeConfig = buildRoutes();
routerHooks.push(Tracking.hook);
routerHooks.push(RedirectTiers.hook);
AuthHooks.forEach(function (hook) {
	routerHooks.push(hook);
});
const locale = window.lang;
//create a store that renders as a side effect if Session is loaded
Reflux.createStore({
	init: function () {
		this.listenTo(SessionStore, this.renderIfNotPending);
		this.renderIfNotPending();
	},
	renderIfNotPending: function () {
		const h = history.get();
		// using the IntlProvider here will not import any messages yet, but will be reused via context
		// guarantees caching and consistent time across verticals
		const wrapper = (
			<div className="main-wrapper">
				<TagPrison />
				<div className="content-container">
					<IntlProvider locale={locale}>
						<Router history={h} routes={routeConfig} />
					</IntlProvider>
				</div>
			</div>
		);

		if (!SessionStore.pending() && document.getElementById("main")) {
			render(wrapper, document.getElementById("main"));
		}
	},
});

// -- BEGIN: ONLY FOR WEB ANALYTICS ---
// This is only relevant and/or interesting for web analytics, hence, we do not send this to the tracking service.
function clickListener(event) {
	const clickedElement = window.event ? window.event.srcElement : event.target;
	// We cannot send the element itself as this is prohibited by contentWindow.postMessage.
	// In addition: why would we want that?
	const eventInfo = {
		"gtm.element": clickedElement.tagName,
		elementType: clickedElement.tagName,
		"gtm.elementClasses": clickedElement.className,
		"gtm.elementId": clickedElement.id,
		"gtm.elementTarget": clickedElement.target,
		"gtm.elementUrl": event.target.href,
	};
	Tracking.trackForGtmOnly("platform", "uidispatcher", "click", {
		tags: eventInfo,
	});
}

if (document.body) {
	/*
  It is miracle to me that this still works.
  All datasources in clickListener are either deprecated or don't have the specified fields according to documentation.
  https://developer.mozilla.org/en-US/docs/Web/API/Window/event
  https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
  TODO check what is actually reported to GTM
   */
	document.body.addEventListener("click", clickListener);
}

// -- END: ONLY FOR WEB ANALYTICS ---
ScrollTracking.startScrollTracking();
Tracking.trackStructuredEvent("platform", "uidispatcher", "app.load", {});
initDatadogRumIfTrackingEnabled();

import("oc_ui/BasicSetup");
